import '../Tests.css';
import { useContext, useEffect, useState } from 'react';
import { SharedVariableContext } from '../../../App';
import translations from './Textes/Assymetry';
// Images
import assymetryImage0 from './Assets/Assymetry0.png';
import assymetryImage1 from './Assets/Assymetry1.png';
import assymetryImage2 from './Assets/Assymetry2.png';
import assymetryImage3 from './Assets/Assymetry3.png';
import assymetryImage4 from './Assets/Assymetry4.png';
import assymetryImage5 from './Assets/Assymetry5.png';
import assymetryImage6 from './Assets/Assymetry6.png';
import assymetryImage7 from './Assets/Assymetry7.png';

export default function TestAssymetry() {
  const { MajTypeDePage, MajIllustration, selectedOption } = useContext(SharedVariableContext);

  // Constantes pour le picture viewer
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Sélectionner la langue, avec français comme langue par défaut
  const lang = translations[selectedOption.value] || translations.fr;

  useEffect(() => {
    MajTypeDePage('Test');
    MajIllustration('BombJackExtraSugarEdition');
  }, [MajTypeDePage, MajIllustration]);


// Fonction pour ouvrir la modale avec l'image sélectionnée
  const openModal = (imageSrc) => 
                                  {
                                  setSelectedImage(imageSrc);
                                  setModalOpen(true);
                                  };

  // Fonction pour fermer la modale
  const closeModal = () => 
                            {
                            setModalOpen(false);
                            setSelectedImage(null);
                            };

//Module pour les images

        //<p className="screenshot">
        //  <img
        //    className="screenshot_image"
        //    src={BombJackExtraSugarEdition1}
        //    alt="Bombjack old"
        //    onClick={() => openModal(BombJackExtraSugarEdition1)}
        //  />
        //  <span className="sousTitreImage">{lang.imageCaptions.bombJackOld}</span>
        //</p>


  return (
    <div id="Test">
      <div id="TestFenetre">
        <h1>{lang.title}</h1>

        {/* Section Intro */}
        <p>{lang.intro.p1}</p>
        <p>{lang.intro.p2}</p>
        <p>{lang.intro.p3}</p>
        <p>{lang.intro.p4}</p>
        <p>{lang.intro.p5}</p>
        <p>{lang.intro.p6}</p>
        <p>{lang.intro.p7}</p>
        
        <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage0}
            alt="écran d'introduction"
            onClick={() => openModal(assymetryImage0)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage0}</span>
        </p>

        {/* Section scenario */}
        <p>{lang.scenario.p1}</p>
        <p>{lang.scenario.p2}</p>
        <p>{lang.scenario.p3}</p>
        <p>{lang.scenario.p4}</p>
        <p>{lang.scenario.p5}</p>
        

        <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage1}
            alt="écran d'introduction"
            onClick={() => openModal(assymetryImage1)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage1}</span>
        </p>

        
        <p>{lang.scenario.p6}</p>
        <p>{lang.scenario.p7}</p>
        <p>{lang.scenario.p8}</p>

        <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage2}
            alt="écran d'introduction"
            onClick={() => openModal(assymetryImage2)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage2}</span>
        </p>

        

        <h2>{lang.jeu.title}</h2>
        <p>{lang.jeu.p1}</p>
        <p>{lang.jeu.p2}</p>
        <p>{lang.jeu.p3}</p>

        <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage3}
            alt="Bien armé"
            onClick={() => openModal(assymetryImage3)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage3}</span>
        </p>

    <h2>{lang.analyseGraphique.title}</h2>
    <p>{lang.analyseGraphique.p1}</p>
    <p>{lang.analyseGraphique.p2}</p>
    <p>{lang.analyseGraphique.p3}</p>
    <p>{lang.analyseGraphique.p4}</p>

    <h2>{lang.gameplay.title}</h2>
    <p>{lang.gameplay.p1}</p>
    <p>{lang.gameplay.p2}</p>
    <p>{lang.gameplay.p3}</p>
    <p>{lang.gameplay.p4}</p>

    <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage4}
            alt="les armes"
            onClick={() => openModal(assymetryImage4)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage4}</span>
    </p>
        
    <p>{lang.gameplay.p5}</p>
    <p>{lang.gameplay.p6}</p>
    <p>{lang.gameplay.p7}</p>
    <p>{lang.gameplay.p8}</p>
    <p>{lang.gameplay.p9}</p>
    <p>{lang.gameplay.p10}</p>

    <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage5}
            alt="BOSS !"
            onClick={() => openModal(assymetryImage5)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage5}</span>
    </p>

    <h2>{lang.son.title}</h2>
    <p>{lang.son.p1}</p>
    <p>{lang.son.p2}</p>
    <p>{lang.son.p3}</p>
    <p>{lang.son.p4}</p>

    <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage6}
            alt="BOSS !"
            onClick={() => openModal(assymetryImage6)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage6}</span>
    </p>


    <h2>{lang.conclusion.title}</h2>
    <p>{lang.conclusion.p1}</p>
    <p>{lang.conclusion.p2}</p>
    <p>{lang.conclusion.p3}</p>
    <p>{lang.conclusion.p4}</p>
    
    <p className="screenshot">
          <img
            className="screenshot_image"
            src={assymetryImage7}
            alt="BOSS !"
            onClick={() => openModal(assymetryImage7)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.assymetryImage7}</span>
    </p>

    <p>{lang.conclusion.p5}</p>

{/* Modale pour afficher l'image en taille réelle */}
        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                ✕
              </button>
              <img src={selectedImage} alt="taille réelle" className="modal-image" />
            </div>
          </div>
        )}


      </div>
    </div>
  );
}